import React from 'react';

import { Routes, Route, useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { toast } from 'react-toastify';
import shortid from 'shortid';
import * as nanoid from 'nanoid';

import OhsTheme from 'global-services/styles/OhsTheme';
import { ModuleRoute, ModuleUrl } from 'global-services/constants/OhsRoutes';
import OhsLoginHome from 'login/OhsLoginHome';
import OhsIframeModulePublicHome from 'global-components/angular-iframe/OhsIframeModulePublicHome';
import OhsRootHome from 'login/OhsRootHome';
import OhsResetPasswordRequest from 'login/password/OhsResetPasswordRequest';
import OhsResetPassword from 'login/password/OhsResetPassword';
import OhsLinkAccessRoutes from 'linkaccess/OhsLinkAccessRoutes';
import OhsApiServices from 'global-services/api/OhsApiServices';
import OhsLoginServices from 'login/OhsLoginServices';
import {
  downloadAttachment,
  getAttachmentList,
  uploadPresignedAttachment,
} from 'global-components/form/fields/attachments/OhsAttachmentServices';
import { getCurrentTimezone } from 'global-services/OhsDataParse';
import OhsStandardCountries from 'global-services/constants/code/OhsStandardCountries';
import { generatedStateOptions } from 'admin2/OhsAdmin2Services';
import OhsVisitorRouteList from 'visitor/OhsVisitorRouteList';
import OhsCorrespondenceLinkAccessHome from 'linkaccess/correspondence/OhsCorrespondenceLinkAccessHome';
import OhsCorrespondenceLinkAccessServices from 'linkaccess/correspondence/OhsCorrespondenceLinkAccessServices';
import addWatermarkToSignature from 'global-services/watermark/addWatermarkToSignature';
import { base64ToBlob } from 'global-services/utils/OhsUtility';
import { uploadPresignedSignature } from 'global-components/form/fields/signature/OhsSignatureServices';
import OhsUserDataServices from 'user/OhsUserDataServices';
import OhsInspectionLinkAccessServices from 'linkaccess/inspection/OhsInspectionLinkAccessServices';
import OhsInspectionLinkAccessHome from 'linkaccess/inspection/OhsInspectionLinkAccessHome';
import OhsQrCodeInvalidOperationHome from 'qr-code/operation/inavalidOperation/OhsQrCodeInvalidOperationHome';
import OhsQrCodeSuccessOperationHome from 'qr-code/operation/successOperation/OhsQrCodeSuccessOperationHome';
import OhsUserLocalServices from 'user/OhsUserLocalServices';
import UITestContainer from 'ui-test/UITestContainer';
import OhsMobileEmbeddedServicesUtils from 'global-components/utils/OhsMobileEmbeddedServicesUtils';
import { useEmbeddedMobile } from 'global-components/utils/OhsUtility';
import OhsAdaCodeExchange from 'ada/landing/OhsAdaCodeExchange';

import OhsPrivateModuleRoutes from './OhsPrivateModuleRoutes';
import OhsAppInstallPrompt from './OhsAppInstallPrompt';

export default function OhsModuleRoutes() {
  const user = OhsUserLocalServices.getLocalOhsUser();
  const navigate = useNavigate();
  const isEmbeddedMobile = useEmbeddedMobile();
  (window as any).moduleUtils = {
    OhsStandardCountries,
    generatedStateOptions,
    getApiRoot: OhsApiServices.getApiRoot(),
    navigate,
    loginByUsernamePassword: OhsLoginServices.loginByUsernamePassword,
    updateSession: OhsApiServices.updateSession,
    resetUserData: OhsUserDataServices.resetUserData,
    shortid,
    nanoid,
    addWatermarkToSignature,
    base64ToBlob,

    isEmbeddedMobile,
  };

  (window as any).root = {
    getAttachmentList,
    uploadPresignedAttachment,
    uploadPresignedSignature,
    downloadAttachment,
    toast,
    getCurrentTimezone,
    user,
    OhsCorrespondenceLinkAccessServices,
    OhsInspectionLinkAccessServices,
    OhsMobileEmbeddedServicesUtils,
  };
  return (
    <Routes>
      <Route path="" element={<OhsRootHome />} />
      <Route
        path={`/${ModuleUrl.Login}`}
        element={
          <ThemeProvider theme={OhsTheme()}>
            <OhsLoginHome />
          </ThemeProvider>
        }
      />

      <Route path="/terms-of-use/*" element={<OhsIframeModulePublicHome />} />
      <Route path="/signup/*" element={<OhsIframeModulePublicHome />} />
      <Route path="/linkaccess/onboarding/*" element={<OhsLinkAccessRoutes />} />
      <Route path="/linkaccess/correspondence/*" element={<OhsCorrespondenceLinkAccessHome />} />
      <Route path="/linkaccess/inspection/*" element={<OhsInspectionLinkAccessHome />} />
      <Route
        path={`/${ModuleUrl.QrCodeGuestInvalid}`}
        element={
          <ThemeProvider theme={OhsTheme()}>
            <OhsQrCodeInvalidOperationHome />
          </ThemeProvider>
        }
      />
      <Route
        path={`/${ModuleUrl.QrCodeGuestSuccess}`}
        element={
          <ThemeProvider theme={OhsTheme()}>
            <OhsQrCodeSuccessOperationHome />
          </ThemeProvider>
        }
      />
      <Route
        path={`/${ModuleUrl.ResetPassword}`}
        element={
          <ThemeProvider theme={OhsTheme()}>
            <OhsResetPasswordRequest />
          </ThemeProvider>
        }
      />
      <Route
        path={`/${ModuleUrl.RecoveryPassword}/:token`}
        element={
          <ThemeProvider theme={OhsTheme()}>
            <OhsResetPassword />
          </ThemeProvider>
        }
      />
      <Route
        path={`/visitor/${OhsVisitorRouteList[ModuleRoute.MobileRedirect].path}`}
        element={<OhsAppInstallPrompt />}
      />
      <Route path={`/${ModuleUrl.AdaCodeExchange}`} element={<OhsAdaCodeExchange />} />
      <Route path="/ui-test/*" element={<UITestContainer />} />
      <Route path="*" element={<OhsPrivateModuleRoutes />} />
    </Routes>
  );
}
